exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-header-minimal[data-v-18390893]{display:-ms-flexbox;display:flex}.o-header-minimal .a-logo[data-v-18390893]{margin:0 auto}\n", ""]);

// exports
